import {
  Box,
  Container,
  Flex,
  Grid,
  Text,
  Image,
  Heading,
} from "@theme-ui/components"
import React, { useContext, useState, useEffect } from "react"
import { useCompany } from "../hooks/useCompany"
import { MagicLink } from "../utils/magicLink"
import { useSocial } from "../hooks/useSocial"
import { useLocation } from "../hooks/useLocation"
import { i18nContext } from "../context/i18nContext"
import { Facebook, Instagram, Youtube, Linkedin } from "react-feather"
import Logo from "../images/logo-white.svg"
import LogoBlack from "../images/logo-rgb.svg"
import { MapPin, Mail } from "react-feather"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { FooterContext } from "../context/footerContext"
import { color } from "framer-motion"
import { useBreakpointIndex } from "@theme-ui/match-media"
import { useColorMode } from "theme-ui"

const Footer = () => {
  const colorMode = useColorMode()
  console.log(colorMode[0])
  const [isDark, setIsDark] = useState(false)
  useEffect(() => {
    colorMode[0] === "dark" ? setIsDark(true) : setIsDark(false)
  }, [colorMode[0]])
  const breakpointIndex = useBreakpointIndex()
  const footer = useContext(FooterContext)
  const company = useCompany()
  const social = useSocial()
  const locations = useLocation()
  const locale = useContext(LanguageSwitcherContext).activeLocale
  console.log(footer)

  footer.map(footerItem => {
    footerItem.treeChildren.sort((a, b) => a.position - b.position)
    footerItem.treeChildren.map(footerItem => {
      if (footerItem.treeChildren.length > 0) {
        footerItem.treeChildren.sort((a, b) => a.position - b.position)
      }
    })
  })

  return (
    <Box
      as="footer"
      sx={{ backgroundColor: "dark", py: [1, 1, 2, 3], color: "light" }}
    >
      <i18nContext.Consumer>
        {t => (
          <>
            <Container>
              <Grid columns={[1, 1, 1, "2fr 1fr 1fr 2fr "]} gap={[6, 5, 5, 9]}>
                {breakpointIndex <= 2 ? (
                  <>
                    {footer.map(column => (
                      <Flex sx={{ flexDirection: "column" }} key={column.id}>
                        <Heading
                          sx={{ fontSize: "16px", textTransform: "uppercase" }}
                        >
                          {" "}
                          {column.anchor}
                        </Heading>
                        <Flex
                          sx={{
                            mt: 3,
                            flexDirection: "row",
                            gap: [2, 2, 2, "21px"],
                            flexWrap: "nowrap",
                            a: {
                              color: "light",
                              color: "light",
                              textDecoration: "none",
                              textTransform: "uppercase",
                              fontFamily: "mono",
                            },
                          }}
                        >
                          {column.treeChildren.map(link => (
                            <>
                              {link.link ? (
                                <Box>
                                  <MagicLink item={link.link} locale={locale} />
                                </Box>
                              ) : (
                                link.anchor
                              )}

                              {link.treeChildren.map(link => (
                                <Box>
                                  {link.link ? (
                                    <MagicLink
                                      item={link.link}
                                      locale={locale}
                                    />
                                  ) : (
                                    link.anchor
                                  )}
                                </Box>
                              ))}
                            </>
                          ))}
                        </Flex>
                      </Flex>
                    ))}
                    <Flex
                      sx={{
                        mt: [5, 5, 5, 0],
                        alignItems: "stretch ",
                        flexDirection: "column",
                        gap: 4,
                        p: { fontSize: 1 },
                        "*:first-child": { mt: 0 },
                      }}
                    >
                      <Image
                        src={Logo}
                        sx={{ maxWidth: "181px", height: "50px" }}
                      />

                      {company.description && (
                        <Text
                          sx={{ fontSize: [2], p: { m: "0px!important" } }}
                          dangerouslySetInnerHTML={{
                            __html: company.description,
                          }}
                        />
                      )}
                    </Flex>
                  </>
                ) : (
                  <>
                    <Flex
                      sx={{
                        alignItems: "stretch ",
                        flexDirection: "column",

                        gap: 4,
                        p: { fontSize: 1 },
                        "*:first-child": { mt: 0 },
                      }}
                    >
                      {isDark ? (
                        <Image
                          src={LogoBlack}
                          sx={{ maxWidth: ["50%", "50%", "300px"] }}
                        />
                      ) : (
                        <Image
                          src={Logo}
                          sx={{ maxWidth: ["50%", "50%", "300px"] }}
                        />
                      )}

                      {company.description && (
                        <Text
                          sx={{ p: { fontSize: "12px", m: "0px!important" } }}
                          dangerouslySetInnerHTML={{
                            __html: company.description,
                          }}
                        />
                      )}
                    </Flex>

                    {footer.map(column => (
                      <List key={column.id}>
                        <Heading
                          sx={{
                            fontSize: "16px",
                            fontFamily: "mono",
                            fontWeight: "normal",
                          }}
                        >
                          {" "}
                          {column.anchor}
                        </Heading>
                        {column.treeChildren.map(link => (
                          <Item>
                            <Text
                              sx={{
                                display: "block",
                                a: {
                                  width: "100%",
                                  whiteSpace: "nowrap",
                                },
                              }}
                            >
                              {link.link ? (
                                <MagicLink item={link.link} locale={locale} />
                              ) : (
                                link.anchor
                              )}
                            </Text>
                            <List key={link.id}>
                              {link.treeChildren.map(link => (
                                <Item>
                                  {link.link ? (
                                    <MagicLink
                                      item={link.link}
                                      locale={locale}
                                    />
                                  ) : (
                                    link.anchor
                                  )}
                                </Item>
                              ))}
                            </List>
                          </Item>
                        ))}
                      </List>
                    ))}
                  </>
                )}
              </Grid>
            </Container>
            <Container sx={{ pb: "0px!important" }}>
              {company && (
                <Box sx={{ mt: [4, 6], color: "light" }}>
                  <Text
                    sx={{
                      fontSize: [1, 1, 2, 1],
                      p: { color: "white!important" },
                    }}
                  >
                    {t.copyright}
                  </Text>
                </Box>
              )}
            </Container>
          </>
        )}
      </i18nContext.Consumer>
    </Box>
  )
}

const List = props => {
  return (
    <Flex
      {...props}
      sx={{
        textTransform: "uppercase",
        flexDirection: "column",
        margin: 0,
        padding: 0,

        gap: [5, 5, 3, 3],
        color: "light",
        color: "light",
        listStyle: "none",
        a: {
          m: 0,
          textDecoration: "none",
          color: "light",
          color: "light",
          "&:hover": {
            textDecoration: "underline",
          },
          li: {
            mb: 0,
            a: {
              color: "white!important",
            },
          },
        },
      }}
      as="ul"
    />
  )
}

const Item = props => {
  return (
    <Box
      {...props}
      as="li"
      sx={{
        fontFamily: "mono",
        a: {
          width: "100%",
        },
        "&:last-child": { mb: 0 },
      }}
    />
  )
}

export default Footer
